export default function AccountDeletionPage() {
  return (
    <section className="max-w-3xl mx-auto px-5 py-12">
      <h1 className="text-3xl font-semibold text-navy">Delete your Inspect Canada account</h1>
      <p className="mt-4 text-slate-700">
        This page explains how to delete your Inspect Canada account and the
        data associated with it. Required by the Google Play and Apple App
        Store account-deletion policies.
      </p>

      <h2 className="text-xl font-semibold text-navy mt-10">In-app deletion (fastest)</h2>
      <ol className="list-decimal pl-6 mt-3 space-y-2 text-slate-700">
        <li>Open the Inspect Canada app on iOS or Android and sign in.</li>
        <li>Tap the profile icon in the top-right of the Home screen.</li>
        <li>Scroll to the bottom of the profile screen and tap <strong>Delete my account</strong>.</li>
        <li>Confirm the action. Your account and the data listed below are
            removed immediately. You will be signed out automatically.</li>
      </ol>

      <h2 className="text-xl font-semibold text-navy mt-10">Email request (if you can't access the app)</h2>
      <p className="mt-3 text-slate-700">
        Email <a href="mailto:support@inspect.ca" className="text-accent underline">support@inspect.ca</a> from
        the address on your account with the subject line <em>"Delete my
        account"</em>. We will confirm receipt within 2 business days and
        complete deletion within 30 days.
      </p>

      <h2 className="text-xl font-semibold text-navy mt-10">What gets deleted</h2>
      <ul className="list-disc pl-6 mt-3 space-y-2 text-slate-700">
        <li>Your Inspect Canada account (email, name, phone, profile photo).</li>
        <li>Your uploaded photos used for AI defect analysis.</li>
        <li>Strata documents you uploaded for AI review and the AI summaries
            generated from them.</li>
        <li>Property addresses + Property Insights searches you ran.</li>
        <li>Saved inspection-report links and Johnni chat history.</li>
        <li>Firebase Cloud Messaging push tokens registered to your account.</li>
      </ul>

      <h2 className="text-xl font-semibold text-navy mt-10">What is kept (and why)</h2>
      <ul className="list-disc pl-6 mt-3 space-y-2 text-slate-700">
        <li><strong>Inspection reports</strong> attached to your account if
            you were the client of a paid home inspection performed by an
            Inspect Canada inspector. We retain these reports for our own
            insurance + regulatory record under the British Columbia
            Home Inspector Act. The report is no longer accessible to you
            in the app after deletion; if you need a copy, request it
            before deleting your account.</li>
        <li><strong>Payment records</strong> for any paid inspection or
            Strata Premium purchase, retained for tax and accounting
            purposes (CRA requires 6 years of business records).</li>
        <li><strong>Anonymized usage analytics</strong> that no longer
            link back to you personally.</li>
      </ul>

      <h2 className="text-xl font-semibold text-navy mt-10">Retention</h2>
      <p className="mt-3 text-slate-700">
        Personal data is removed from our active systems within 30 days of
        the deletion request. Backup snapshots that may contain personal
        data are purged within 90 days of the request.
      </p>

      <h2 className="text-xl font-semibold text-navy mt-10">Questions</h2>
      <p className="mt-3 text-slate-700">
        Email <a href="mailto:support@inspect.ca" className="text-accent underline">support@inspect.ca</a>. See
        our <a href="https://inspect.ca/privacy" className="text-accent underline">Privacy Policy</a> for
        more on how we handle your data.
      </p>

      <p className="mt-12 text-xs text-slate-400">
        In Spect Building Consultants Inc. dba Inspect Canada — last
        updated {new Date().toISOString().slice(0, 10)}.
      </p>
    </section>
  );
}
